import '../../styles/layout.css'
import '../../styles/typography.css'
import '../../styles/colours.css'
import '../../styles/controls.css'
import '../../styles/index.css'
import './index.css'
import '../../utility/reportUnhandledRejection'
import { useEffect, useRef } from 'react'
import StaticHeader from '../shared/header/static-header'
import ThreeGradient from '../shared/three-gradient/three-gradient'
import Analytics from '../../utility/Analytics'
import { createRoot } from 'react-dom/client'
import Button from '../shared/mega-button/mega-button'

// On a phone, focusing a field as the page loads makes iOS scroll / zoom before anyone has touched
// anything, so only autofocus with a mouse
const isTouchScreen = window.matchMedia('(pointer: coarse)').matches

const Application = () => {
  const submitForm = useRef<HTMLFormElement>(null)

  useEffect(() => {
    Analytics.triggerEvent('Page Load', { screen_name: 'Login' })
  }, [])

  const doSubmitForm = () => {
    if (!submitForm.current) return
    submitForm.current.submit()
  }

  return (
    <ThreeGradient showImages={true}>
      <div className='application-frame'>
        <StaticHeader />
        <div className='login-frame'>
          <form action='/login' method='post' ref={submitForm}>
            <h2>
              Login to your online<br></br>SimUI account
            </h2>
            <input
              type='text'
              placeholder='Email Address'
              name='username'
              autoFocus={!isTouchScreen}
              autoComplete='username'
              inputMode='email'
              autoCapitalize='none'
              autoCorrect='off'
              spellCheck={false}
              tabIndex={1}
            />
            <input
              type='password'
              placeholder='Password'
              name='password'
              autoComplete='current-password'
              tabIndex={2}
            />
            <a href='/reset'>Reset password</a>
            <Button onClick={() => doSubmitForm()}>Login</Button>
          </form>
        </div>
      </div>
    </ThreeGradient>
  )
}

const root = createRoot(document.getElementById('app'))
root.render(
  <Application />
)
